<template>
  <div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="90px"
             class="demo-ruleForm">
      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="姓名:" prop="name"> 
            <el-input v-model="ruleForm.name" placeholder="必填，2-10个字"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="mobile">
            <el-input v-model="ruleForm.mobile" placeholder="必填，请输入11位手机号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="邮箱:" prop="email">
            <el-input v-model="ruleForm.email" placeholder="必填，不超过60个字"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码:" prop="mypassword">
            <el-input v-model="ruleForm.mypassword" show-password placeholder="必填，8-16个字，请尽量复杂！"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="企业:" prop="company">
            <el-input v-model="ruleForm.company" placeholder="请输入企业"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="岗位:" prop="job">
            <el-input v-model="ruleForm.job" placeholder="请输入岗位"></el-input>
          </el-form-item>
        </el-col>
        
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="部门:" prop="departmentId" style="width:100%">
            <el-select style="width:100%" v-model="ruleForm.departmentId" placeholder="请选择">
              <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="资源空间:" prop="resourceSpace" v-if="ruleForm.userType=='0'">
            <el-input-number v-model="ruleForm.resourceSpace" :step="1" :min="1" ></el-input-number>
            <el-tag type="info" size="large">G</el-tag>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-form-item label="用户类型:" prop="userType">
          <el-radio-group v-model="ruleForm.userType" :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'">
            <el-radio-button label="0">内部用户</el-radio-button>
            <el-radio-button label="1">外部用户</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-form-item label="用户备注:"
                      prop="desc">
          <el-input type="textarea"
                    v-model="ruleForm.desc"
                    placeholder="选填，用户备注不超过200个字"></el-input>
        </el-form-item>
      </el-row>

      <el-form-item v-if="ruleForm.userType == 0"
                    label="用户角色:"
                    prop="myroleIds">
        <el-checkbox-group :max="5"
                           v-model="ruleForm.myroleIds">
          <el-checkbox v-for="(e,i) in roleName"
                       :label="e.id"
                       :key="i"
                       name="myroleIds">{{e.name}}</el-checkbox>
          <!-- <el-checkbox label="记者" name="myroleIds"></el-checkbox>
              <el-checkbox label="编辑" name="myroleIds"></el-checkbox>
              <el-checkbox label="测试用户" name="myroleIds"></el-checkbox>
              <el-checkbox label="主编" name="myroleIds"></el-checkbox> -->
        </el-checkbox-group>
      </el-form-item>

      <div class="xianzhi"
           v-if="ruleForm.myroleIds.length > 4">用户角色限制选择5个</div>

      <!-- <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item> -->
    </el-form>

    <div class="bottombtn">
      <div class="btn">
        <el-button @click="closeForm">取消</el-button>
        <el-button @click="submitForm('ruleForm')"
                   v-if="!isClick"
                   :style="isSimple?'background-color:#fd9112;border:1px solid #fd9112;':''"
                   type="primary">确认</el-button>
        <el-button disabled
                   v-else
                   type="primary">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDate } from "@/plugins/getdate";
import { listAuthRole } from "@/api/authRole";
import { getDepartmentListApi } from "@/api/department";

export default {
  data () {
    return {
      isClick: false,
      roleName: [],
      departmentList:[],
      ruleForm: {
        name: '',
        mobile: '',
        email: '',
        mypassword: '',
        myroleIds: [],
        userType: '0',
        desc: '',
        company: '',
        departmentId: "",
        resourceSpace:undefined,
        desc: '',
        sort: 0,
        status: 0
        // createAt:''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'change' },
          { min: 11, max: 11, message: '长度在11 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          { min: 0, max: 60, message: '长度不得超过60个字符', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ],
        mypassword: [
          { required: true, message: '请输入密码', trigger: 'change' },
          { min: 8, max: 16, message: '长度在8 到 16 个字符', trigger: 'blur' }
        ],
        // myroleIds: [
        //   { type: 'array', required: true, message: '请至少选择一个用户角色', trigger: 'change' }
        // ],
        departmentId: [
          { required: true, message: '请选择部门', trigger: 'change' },
        ],
        resourceSpace: [
          { required: true, message: '请配置资源空间', trigger: 'change' },
        ],
        
        userType: [
          { required: true, message: '请选择用户类型', trigger: 'change' }
        ],
        desc: [
          { min: 0, max: 200, message: '长度不得超过200个字符', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isClick = true
          setTimeout(() => {
            this.isClick = false
          }, 2000);
          let { systemDate } = getDate()
          if (this.ruleForm.myroleIds.length === 0) {
            this.ruleForm.roleIds = null
          } else {
            this.ruleForm.roleIds = this.ruleForm.myroleIds.toString()
          }

          this.$emit('submitForm', this.ruleForm)
        } else {
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    closeForm () {
      this.$emit('closeForm')
    },

    //获取角色列表
    async listAuthRoleAsync () {
      let { status, data, message, errors } = await listAuthRole({ pageSize: 100 });
      if (status) {
        this.roleName = data
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    async listDepartmentAsync () {
      let { status, data, message } = await getDepartmentListApi({ status:1,pageSize: 100 });
      if (status) {
        this.departmentList = data
      } else {
        console.log(message);
      }
    },
  },
  created () {
    this.listAuthRoleAsync()
    this.listDepartmentAsync()

  }
}
</script>

<style lang="scss" scoped>
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 2px;
  // top: 0;
  // z-index: 99;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn ::v-deep .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn ::v-deep .el-button--primary {
  background-color: #185ed3;
}
::v-deep .el-form-item__label {
  font-weight: 600;
}

.xianzhi {
  font-size: 13px;
  color: red;
  margin: -15px 0 0 90px;
}
</style>
